<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-user"></em> General Information</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{emp_name}}
                </div>
              </div>
              <div class="form-row" v-if="data !== null">
                <label class="col-md-3">Transaction Number</label>
                <div class="col-md-6 mb-3">
                  {{data.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Overtime Date</label>
                <div class="col-8 mb-3">
                  <div class="row" v-for="(item, i) in items">

                    <div class="col-3 mb-1">
                      <flat-pickr :config="config" v-model="item.date"></flat-pickr>
                    </div>
                    <div class="col-4 mb-1">
                      <b-form-select :options="option_hours" v-model="item.hours"></b-form-select>
                    </div>
                    <div class="col-1 mb-1" v-if="i ==0">
                      <button type="button" class="btn btn-success btn-sm" @click="addItem" data-title="Add">
                        <em class="fa fa-plus mr-1"></em>Add</button>
                    </div>
                    <div class="col-1 mb-1" v-else>
                      <em class="fa fa-trash mr-1" style="cursor: pointer" @click="deleteItem(i)"></em>
                    </div>
                  </div>
                </div>


              </div>
              <div class="form-row" v-if="this.$store.getters.isMultiple">
                <label class="col-md-3">Project</label>
                <div class="col-md-6 mb-3">
                  <v-select :options="option_project" v-model="input_data.project" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Note</label>
                <div class="col-md-6 mb-3">
                  <b-form-textarea rows="3" v-model="input_data.reason" max-rows="6"></b-form-textarea>
                </div>
              </div>
              <template v-if="!this.$store.getters.companySettings.is_auto_approve">
                <hr/>
                <legend><em class="fa fa-users"></em> Approval Information</legend>
                <list-supervisor :emp_id="emp_id"></list-supervisor>
              </template>

            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="stat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="stat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {BForm, BFormGroup, BFormInput, BFormTextarea, BFormFile, BButton, BFormSelect, BModal} from "bootstrap-vue"
import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import ListSupervisor from "../employee/ListSupervisor";
export default {
  name: "CompensatoryOvertimeInput",
  components:{
    ListSupervisor,
    Breadcrumb,
    BForm,
    BFormGroup,
    BFormInput,
    flatPickr,
    BFormTextarea,
    BFormFile,
    BButton,
    BFormSelect,
    BModal,
    vSelect
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      emp_name:"",
      emp_id:"",
      input_data:{
        project:"",
        reason:"",
        file:[]
      },
      items:[{hours:8}],
      items_deleted:[],
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
      stat_id:0,
      option_project:[],
      option_currency:[],
      option_hours:[]
    }
  },
  methods:{
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    resetModal(){
      this.items = [{hours:8}]
      this.$parent.data = null
      this.input_data = {
        project:"",
        reason:"",
        file:[]
      }
      this.items_deleted = []
      this.$refs.modal.hide()
    },
    onSubmit(){

      if(!this.checkValidItem()){
        return false
      }
      let userProfile = this.$store.getters.userProfile.data.attributes
      let payload = {
        emp_id:this.$store.getters.empId,
        user_id:this.$store.getters.userId,
        compover_unit_id: userProfile.emp_unit_id,
        compover_activity:this.items,
        compover_project_id:this.input_data.project,
        compover_reason:this.input_data.reason,
        compover_compstat_id:this.stat_id,

      }

      if (this.data !== null){
        payload.id = this.data.id
        payload.compover_number=this.data.number
        payload.comp_activity_deleted = this.items_deleted
        AxiosCall.Put(payload, urlApi.compensatory_overtime.update).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else {
        AxiosCall.Post(payload, urlApi.compensatory_overtime.add).then(res=>{
          if(res.success){
            this.$parent.getData()
            this.$parent.successMessage(res.message)
            this.$refs.modal.hide()
          }else {
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    checkValidItem(){
      if (this.items.length == 0){
        this.$parent.errorMessage('Pleas add item')
        return false
      }

      for (let data of this.items){
        if (data.date === undefined || data.date==="" || data.date === null){
          this.$parent.errorMessage("Please fill date.")
          return false
        }
      }
      return true
    },
    onBack(){
      this.$router.push({path:"/work-from-home"})
    },
    addItem(){
      this.items.push({hours:8})
    },
    deleteItem(i){
      this.items_deleted.push(this.items[i])
      this.items.splice(i, 1)
    },
    setData(){
      this.getProject()
      setTimeout(()=>{
        this.emp_id = this.$store.getters.empId.toString()
        if(this.data !== null){
          this.getDetail()
        }
      },100)
    },
    getProject(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(res=>{
        if(res.success){
          this.option_project = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getDetail(){
      let paylaod = {
        id:this.data.id
      }
      AxiosCall.Get(paylaod, urlApi.compensatory_overtime.detail).then(res=>{
        if(res.success){
          this.items = JSON.parse(res.atributes.items)
          this.input_data = {
            emp_id:res.atributes.emp_id,
            reason:res.atributes.reason,
            project:res.atributes.project_id
          }
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    }
  },
  mounted() {
    for (let i = 1; i<=12; i++){
      this.option_hours.push({text:i+" hours", value:i})
    }
    let userProfile = this.$store.getters.userProfile.data.attributes
    this.emp_name = userProfile.emp_name
    this.emp_id = userProfile.emp_id.toString()
  }
}
</script>